import React from "react";
import "./Header.css";
import {useTranslation} from "react-i18next";

export default function Header() {

    const {t} = useTranslation();

    return (
        <>
            <header className="pt-3">
                <div className="container flex justify-center lg:justify-start mx-auto center px-4 pt-3">
                    <a href={"/"}
                       className="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto text-dark text-decoration-none"
                       alt="mongolbank.mn" title="mongolbank.mn">
                        <img src={"/logo/" + t('root.header-logo')} className={"logo"} id="header_logo"
                             alt="mongolbank.mn"/>
                    </a>
                </div>
            </header>
        </>
    );
}
